const deprecatedEvent = [
  { label: "โอนกรรมสิทธิ์ 1%", value: "NEW_HOME_COIN_ONE_PERCENT" },
  { label: "เปิดกระเป๋า wallet", value: "CUSTOMER_CREATE_WALLET" },
  { label: "ซื้อของ RJ 1%", value: "BUY_RJ_PACKAGE_ONE_PERCENT" },
  { label: "ซื้อของ RJ 2%", value: "BUY_RJ_PACKAGE_TWO_PERCENT" }
];

export const mappingDeprecatedEvent = (eventCode) => {
  let result = '-'
  if (!eventCode) return result
  const map = deprecatedEvent.find(
    val => val.value === eventCode
  );
  if (!map) return result
  return map.label
};



// WEBPACK FOOTER //
// ./src/features/morning-coin/utils/mapHelper.js